import { defineComponent as y, useSlots as I, ref as $, openBlock as c, createElementBlock as l, createElementVNode as d, renderSlot as i, createBlock as p, Transition as a, withCtx as s, createVNode as r, unref as f, createCommentVNode as n, toDisplayString as m, createTextVNode as v } from "vue";
import "./novoui-vuejs80.js";
/* empty css               */
import "./novoui-vuejs89.js";
/* empty css               */
import "./novoui-vuejs4.js";
import "./novoui-vuejs5.js";
import "./novoui-vuejs6.js";
import "./novoui-vuejs7.js";
import "./novoui-vuejs8.js";
import "./novoui-vuejs11.js";
import u from "./novoui-vuejs12.js";
import "./novoui-vuejs48.js";
import "./novoui-vuejs14.js";
import "./novoui-vuejs15.js";
import "./novoui-vuejs16.js";
import "./novoui-vuejs17.js";
import "./novoui-vuejs18.js";
import B from "./novoui-vuejs20.js";
import "./novoui-vuejs21.js";
import "./novoui-vuejs30.js";
import "./novoui-vuejs24.js";
import "./novoui-vuejs25.js";
import "./novoui-vuejs26.js";
import "./novoui-vuejs27.js";
import "./novoui-vuejs29.js";
import "./novoui-vuejs31.js";
import "./novoui-vuejs32.js";
import "./novoui-vuejs33.js";
import "./novoui-vuejs34.js";
import "./novoui-vuejs35.js";
import "./novoui-vuejs36.js";
import "./novoui-vuejs37.js";
import "./novoui-vuejs38.js";
import "./novoui-vuejs42.js";
/* empty css                */
import "./novoui-vuejs45.js";
import "./novoui-vuejs47.js";
const C = { class: "accordion-item" }, N = { class: "accordion-item-header" }, A = { class: "accordion-item-title" }, T = {
  key: 0,
  class: "accordion-item-footer"
}, V = {
  key: 0,
  class: "accordion-item-content"
}, ve = /* @__PURE__ */ y({
  __name: "NAccordionItem",
  props: {
    hideLeadningIcon: { type: Boolean, default: !0 },
    hideTrailingIcon: { type: Boolean },
    title: {},
    footer: {},
    content: {},
    isActive: { type: Boolean, default: !1 }
  },
  emits: [
    /**
     * Emit when the collapse is active
     */
    "click"
  ],
  setup(_, { emit: h }) {
    const e = _;
    I();
    const k = h, o = $(e.isActive), g = () => {
      o.value = !o.value, k("click", o.value);
    };
    return (t, w) => (c(), l("div", C, [
      d("div", {
        onClick: g,
        class: "accordion-cursor-pointer"
      }, [
        d("div", N, [
          i(t.$slots, "leadingIcon", {}, () => [
            e.hideLeadningIcon ? n("", !0) : (c(), p(a, {
              key: 0,
              "enter-from-class": "accordion-effect-enter-leave",
              "leave-to-class": "accordion-effect-enter-leave",
              "enter-active-class": "accordion-effect-transition accordion-effect-duration-300",
              "leave-active-class": "accordion-effect-transition accordion-effect-duration-300"
            }, {
              default: s(() => [
                r(f(u), {
                  icon: o.value ? "chevronUp" : "chevronDown",
                  class: "accordion-item-prepend-icon"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          ]),
          i(t.$slots, "title", {}, () => [
            d("div", A, m(e.title), 1)
          ]),
          i(t.$slots, "trailingIcon", {}, () => [
            e.hideTrailingIcon ? n("", !0) : (c(), p(a, {
              key: 0,
              "enter-from-class": "accordion-effect-enter-leave",
              "leave-to-class": "accordion-effect-enter-leave",
              "enter-active-class": "accordion-effect-transition accordion-effect-duration-300",
              "leave-active-class": "accordion-effect-transition accordion-effect-duration-300"
            }, {
              default: s(() => [
                r(f(u), {
                  icon: o.value ? "chevronUp" : "chevronDown",
                  class: "accordion-item-append-icon"
                }, null, 8, ["icon"])
              ]),
              _: 1
            }))
          ])
        ]),
        r(a, {
          "enter-from-class": "accordion-effect-enter-leave",
          "leave-to-class": "accordion-effect-enter-leave",
          "enter-active-class": "accordion-effect-transition accordion-effect-duration-500",
          "leave-active-class": "accordion-effect-transition accordion-effect-duration-500"
        }, {
          default: s(() => [
            o.value ? n("", !0) : i(t.$slots, "footer", { key: 0 }, () => [
              e.footer ? (c(), l("div", T, [
                r(f(B), { class: "accordion-item-footer-divider" }),
                v(" " + m(e.footer), 1)
              ])) : n("", !0)
            ])
          ]),
          _: 3
        })
      ]),
      r(a, {
        "enter-from-class": "accordion-effect-enter-leave",
        "leave-to-class": "accordion-effect-enter-leave",
        "enter-active-class": "accordion-effect-transition accordion-effect-duration-500",
        "leave-active-class": "accordion-effect-transition accordion-effect-duration-500"
      }, {
        default: s(() => [
          o.value ? (c(), l("div", V, [
            i(t.$slots, "content", {}, () => [
              v(m(e.content), 1)
            ])
          ])) : n("", !0)
        ]),
        _: 3
      })
    ]));
  }
});
export {
  ve as default
};
